
















































import { Component, PropSync, Vue } from 'vue-property-decorator';
import {
	FlowChartsApi,
	WaterLinksApi,
	WaterMetersApi,
	WaterMonitorsApi,
	WaterTanksApi,
} from '@/api';
import FlowContainer from '@/components/flow/flow-container/flow-container';

@Component({
	components: { FlowContainer },
	props: {},
})
export default class WaterLinks extends Vue {
	private waterLinksApi: WaterLinksApi = new WaterLinksApi();
	private flowChartsApi: FlowChartsApi = new FlowChartsApi();
	public entityNodes: any[] = [];
	public entityLinks: any[] = [];
	public editWaterLinks: boolean = false;
	private waterMetersApi: WaterMetersApi = new WaterMetersApi();
	private waterTanksApi: WaterTanksApi = new WaterTanksApi();
	private waterMonitorsApi: WaterMonitorsApi = new WaterMonitorsApi();

	@PropSync('product') public localProduct!: object;
	@PropSync('tanks') public localTanks!: any[];
	@PropSync('meters') public localMeters!: any[];
	@PropSync('monitors') public localMonitors!: any[];
	public created() {
		this.loadWaterLinks();
	}
	public async loadWaterLinks() {
		this.entityNodes = [
			...this.localMeters.map((meter, index) => ({
				id: meter.id,
				x: 20 + index * 150,
				y: 20,
				type: 'Water Supply',
				label: meter.name,
				subLabel: meter.status,
				connectedTop: null,
				connectedBottom: null,
			})),
			...this.localTanks.map((tank, index) => ({
				id: 10000 + tank.id,
				x: 20 + index * 150,
				y: 160,
				type: 'Water Tank',
				label: tank.name,
				subLabel: tank.status,
				connectedTop: null,
				connectedBottom: null,
			})),
			...this.localMonitors.map((monitor, index) => ({
				id: 20000 + monitor.id,
				x: 20 + index * 150,
				y: 300,
				type: 'Water Usage',
				label: monitor.name,
				subLabel: `${monitor.status} ${monitor.position || 'inline'}`,
				connectedTop: null,
				connectedBottom: null,
			})),
		];
		const layoutResponse = await new FlowChartsApi().getFlowChartLayout(
			this.localProduct.id,
			'products',
		);
		if (layoutResponse.data.data !== undefined && layoutResponse.data.data.length > 0) {
			const layout = JSON.parse(layoutResponse.data.data[0].layout);
			this.entityNodes.forEach(node => {
				const storedNode = layout.nodes.find((n: any) => n.id === node.id);
				if (storedNode == null) {
					return;
				}
				node.x = storedNode.x;
				node.y = storedNode.y;
				node.connectedTop = storedNode.connectedTop;
				node.connectedBottom = storedNode.connectedBottom;
			});
		}

		const links: any[] = [];
		this.localMeters.forEach((meter: any) => {
			this.fromEntity(links, meter, 0);
		});
		this.localTanks.forEach((tank: any) => {
			this.fromEntity(links, tank, 10000);
		});
		this.localMonitors.forEach((monitor: any) => {
			this.fromEntity(links, monitor, 20000);
		});
		this.entityLinks = links;
	}

	public saveWaterLinks() {
		this.editWaterLinks = false;

		const waterLinks: WaterLink[] = [];
		for (const link of this.entityLinks) {
			let fromId: number;
			let fromType: string;
			let toId: number;
			let toType: string;

			if (link.from < 10000) {
				fromId = link.from;
				fromType = 'waterMeters';
			} else if (link.from < 20000) {
				fromId = link.from - 10000;
				fromType = 'waterTanks';
			} else {
				fromId = link.from - 20000;
				fromType = 'waterMonitors';
			}

			if (link.to < 10000) {
				toId = link.to;
				toType = 'waterMeters';
			} else if (link.to < 20000) {
				toId = link.to - 10000;
				toType = 'waterTanks';
			} else {
				toId = link.to - 20000;
				toType = 'waterMonitors';
			}
			waterLinks.push({
				inObject_id: toId,
				inObject_type: toType,
				outObject_id: fromId,
				outObject_type: fromType,
			});
		}

		const updatedWaterMeters: WaterMeterInfo[] = [];
		const updatedWaterTanks: WaterTankInfo[] = [];
		const updatedWaterMonitors: WaterMonitorInfo[] = [];

		for (const node of this.entityNodes) {
			let position;
			let id;
			if (node.id < 10000) {
				position = 'outlet';
				id = node.id;
				updatedWaterMeters.push({
					id,
					productId: this.localProduct.id,
					position,
				});
			} else if (node.id < 20000) {
				position = 'level';
				id = node.id - 10000;
				updatedWaterTanks.push({
					id,
					productId: this.localProduct.id,
					position,
				});
			} else {
				position =
					(node.connectedTop != null && node.connectedBottom != null) ||
					(node.connectedTop == null && node.connectedBottom == null)
						? 'inline'
						: node.connectedTop != null
						? 'outlet'
						: 'inlet';
				node.subLabel = `${node.subLabel.split(' ')[0]} ${position}`;
				id = node.id - 20000;
				updatedWaterMonitors.push({
					id,
					productId: this.localProduct.id,
					position,
				});
			}
		}

		if (updatedWaterMeters.length > 0) {
			this.waterMetersApi.bulkUpdateWaterMeters({
				data: updatedWaterMeters,
			});
		}

		if (updatedWaterTanks.length > 0) {
			this.waterTanksApi.bulkUpdateWaterTanks({
				data: updatedWaterTanks,
			});
		}

		if (updatedWaterMonitors.length > 0) {
			this.waterMonitorsApi.bulkUpdateWaterMonitors({
				data: updatedWaterMonitors,
			});
		}

		this.waterLinksApi.updateWaterLinks({
			data: {
				productId: this.localProduct.id,
				links: waterLinks,
			},
		});

		this.flowChartsApi.updateFlowChartLayout(this.localProduct.id, 'products', {
			data: {
				ownerId: this.localProduct.id,
				ownerType: 'products',
				layout: JSON.stringify({
					nodes: this.entityNodes,
				}),
			},
		});
	}

	public resetWaterLinks() {
		this.entityNodes.forEach((node: any, i: number) => {
			let index = i;
			if (node.id >= 20000) {
				index -= this.entityNodes.filter(n => n.id < 20000).length;
			} else if (node.id >= 10000) {
				index -= this.entityNodes.filter(n => n.id < 10000).length;
			}
			node.x = 20 + index * 150;
			node.y = node.id < 10000 ? 20 : node.id < 20000 ? 140 : 260;
			node.connectedTop = null;
			node.connectedBottom = null;
		});
	}

	private fromEntity(links: any[], fromEntity: any, idOffset: number) {
		fromEntity.watermeterouts.forEach((toEntity: any) => {
			this.toEntity(links, fromEntity.id + idOffset, toEntity.id);
		});
		fromEntity.watertankouts.forEach((toEntity: any) => {
			this.toEntity(links, fromEntity.id + idOffset, toEntity.id + 10000);
		});
		fromEntity.watermonitorouts.forEach((toEntity: any) => {
			this.toEntity(links, fromEntity.id + idOffset, toEntity.id + 20000);
		});
	}

	private toEntity(links: any[], fromId: any, toId: any) {
		links.push({
			id: `${fromId},${toId}`,
			from: fromId,
			to: toId,
		});
	}

	public acknowledgeWaterLinks() {
		localStorage.setItem('WATER_LINKS_ACKNOWLEDGED', 'true');
		this.$nextTick(() => {
			this.$bvModal.hide('water-links-modal');
		});
	}

	public onWaterLinksModalHide(event: any) {
		if (localStorage.getItem('WATER_LINKS_ACKNOWLEDGED') == null) {
			event.preventDefault();
		}
	}
}
